/**
 * SweetAlert2 instancia pre-configurada con el tema de KIA (azul oscuro #05141F)
 */
import Swal from 'sweetalert2';

const KiaSwal = Swal.mixin({
  confirmButtonColor: '#05141f',
  cancelButtonColor: '#6c757d',
  customClass: {
    confirmButton: 'swal-kia-confirm',
    popup: 'swal-kia-popup',
  },
  buttonsStyling: true,
  focusConfirm: false,
});

export default KiaSwal;


